import React from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";

import Phone1 from "assets/images/coming-soon/iphone-image-1.png";
import Phone2 from "assets/images/coming-soon/iphone-image-2.png";
import Phone3 from "assets/images/coming-soon/iphone-image-3.png";
import { formatTitleWithItalic } from "utils";

function Features({ data }) {
  const icons = [Phone1, Phone2, Phone3];

  return (
    <Container fluid className="container feature">
      {data?.features?.map((item, index) => (
        <div
          className={`outer-box ${index % 2 === 0 ? "row-direction" : "row-reverse-direction"}`}
          data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
          data-aos-delay="150"
        >
          <div
            className="content-box"
            style={{
              textAlign: index % 2 === 0 ? "right" : "left",
            }}
          >
            <span>{formatTitleWithItalic(item?.tagline)}</span>
            <h3>{formatTitleWithItalic(item?.title)}</h3>
            {item?.description && parse(item?.description)}
          </div>
          <div className="coming-soon-image-container">
            <img
              src={item?.image || item?.imageLink}
              alt="Iphone Icon"
              className="d-block"
              width="100%"
            />
          </div>
        </div>
      ))}
      {/* <div className="outer-box" data-aos="fade-right" data-aos-delay="150">
        <div className="content-box">
          <span>Stay on top of your finances</span>
          <h3>Receive proactive alerts</h3>
          <p>
            Help protect your account with Eno, your Capital One assistant, Eno
            looks out for transaction that might surprise you, like a duplicate
            charge.
          </p>
        </div>
        <div className="image-container">
          <img
            src={Phone1}
            alt="Iphone Icon"
            className="d-block"
            width="100%"
          />
        </div>
      </div>
      <div className="outer-box" data-aos="fade-left" data-aos-delay="150">
        <div className="image-container">
          <img
            src={Phone2}
            alt="Iphone Icon"
            className="d-block"
            width="100%"
          />
        </div>
        <div className="content-box">
          <span>Manage your cards from anywhere</span>
          <h3>Lock your card</h3>
          <p>
            Misplaced your card? Lock it from the app to keep others from using
            it. If your card is found, you can unlock it just as fast.
          </p>
        </div>
      </div>
      <div className="outer-box" data-aos="fade-right" data-aos-delay="150">
        <div className="content-box">
          <span>Monitor recent transaction</span>
          <h3>View recent activity</h3>
          <p>
            Keep track of your spending and see all your transaction with
            detailed information.
          </p>
        </div>
        <div className="image-container">
          <img
            src={Phone3}
            alt="Iphone Icon"
            className="d-block"
            width="100%"
          />
        </div>
      </div> */}
    </Container>
  );
}

export default Features;
